import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

const LOGO_URL = "/logo_white.png";

const footerLinks = {
  product: [
    { name: 'Overview', path: '/product' },
    { name: 'Modules', path: '/modules' },
    { name: 'Standards', path: '/standards' },
    { name: 'Security', path: '/security' },
  ],
  solutions: [
    { name: 'For Exporters', path: '/solutions#exporters' },
    { name: 'For Inspectors', path: '/solutions#inspectors' },
    { name: 'For Regulators', path: '/solutions#regulators' },
    { name: 'For Trade Partners', path: '/solutions#trade-partners' },
  ],
  company: [
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'Terms of Service', path: '/terms' },
  ],
};

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <img 
              src={LOGO_URL} 
              alt="Certisfy" 
              className="h-10 w-auto mb-6"
            />
            <p className="text-slate-400 text-sm leading-relaxed mb-6 max-w-sm">
              National-grade phytosanitary certification and export compliance management. 
              Streamlining agricultural trade across Southern Africa.
            </p>
            <p className="text-[#C8A24A] font-medium text-sm">CERTIFIED | TRACEABLE | TRUSTED</p>
            
            {/* Contact Info */}
            <div className="mt-8 space-y-3">
              <a 
                href="mailto:info@certisfy.cloud" 
                className="flex items-center gap-3 text-slate-400 hover:text-white text-sm"
                style={{ transition: 'color 0.2s' }}
              >
                <Mail className="w-4 h-4" />
                info@certisfy.cloud
              </a>
              <a 
                href="tel:+27000000000" 
                className="flex items-center gap-3 text-slate-400 hover:text-white text-sm"
                style={{ transition: 'color 0.2s' }}
              >
                <Phone className="w-4 h-4" />
                +27 (0) 71 336 0548
              </a>
              <div className="flex items-center gap-3 text-slate-400 text-sm">
                <MapPin className="w-4 h-4" />
                Pretoria, South Africa
              </div>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Product</h4>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-slate-400 hover:text-white text-sm"
                    style={{ transition: 'color 0.2s' }}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Solutions Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Solutions</h4>
            <ul className="space-y-3">
              {footerLinks.solutions.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-slate-400 hover:text-white text-sm"
                    style={{ transition: 'color 0.2s' }}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-slate-400 hover:text-white text-sm"
                    style={{ transition: 'color 0.2s' }}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-sm">
              &copy; {currentYear} Certisfy. All rights reserved.
            </p>
            
            {/* Social Links */}
            <div className="flex items-center gap-4">
              <a 
                href="#" 
                aria-label="LinkedIn"
                className="text-slate-500 hover:text-white p-2 rounded-full hover:bg-slate-800"
                style={{ transition: 'color 0.2s, background-color 0.2s' }}
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                aria-label="Twitter"
                className="text-slate-500 hover:text-white p-2 rounded-full hover:bg-slate-800"
                style={{ transition: 'color 0.2s, background-color 0.2s' }}
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                aria-label="Facebook"
                className="text-slate-500 hover:text-white p-2 rounded-full hover:bg-slate-800"
                style={{ transition: 'color 0.2s, background-color 0.2s' }}
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
